const serviceNameMapping = {
  'SIPPROXY-INCOMING-CALL': {
    display: '555 received incoming call',
    status: 'info',
  },
  'SIPPROXY-CALL-SETUP-IN-PROGRESS': {
    display: 'Call Setup in progress',
    status: 'info',
  },
  'SIPPROXY-CALL-REJECTED': {
    display: '555 rejected the call',
    status: 'info',
  },
  'SIPPROXY-FARSIDE-RINGING': {
    display: 'Ringing callee',
    status: 'info',
  },
  'SIPPROXY-SIGNALING-ESTABLISHED': {
    display: 'Call Connected',
    status: 'info',
  },
  'SIPPROXY-HANGUP-TO-SIP': {
    display: 'Sending disconnect to PSTN network',
    status: 'info',
  },
  'SIPPROXY-HANGUP-TO-RTC': {
    display: 'Received disconnect from PSTN network',
    status: 'info',
  },
  'SIPPROXY-NOT-A-SUBSCRIBER': {
    display: 'Callee not subscribed',
    status: 'alert',
  },
  'SIPPROXY-INVALID-TN': {
    display: 'Destination TN is not valid',
    status: 'alert',
  },
  'SIPPROXY-BLACKLISTED': {
    display: 'Call to a blacklisted number',
    status: 'alert',
  },
  'SIPPROXY-FRAUD-ALERT': {
    display: 'Call flagged high risk',
    status: 'alert',
  },
  'NTM-PUBLISH-ERROR': {
    display: 'Unable to notify callee',
    status: 'alert',
  },
  'NTM-NO-SUBSCRIBERS': {
    display: 'Callee not subscribed',
    status: 'alert',
  },
  'NTM-NOTIFIED-WEBN': {
    display: 'Callee notified over WebHook',
    status: 'info',
  },
  'NTM-RECEIVED-PUBLISH_REQUEST': {
    display: 'Push notification request received',
    status: 'info',
  },
  'NTM-NOTIFIED-WSS': {
    display: 'Callee notified over WSS',
    status: 'info',
  },
  'NTM-NOTIFIED-APNS': {
    display: 'Callee notified over APNS',
    status: 'info',
  },
  'NTM-NOTIFIED-FCM': {
    display: 'Callee notified over FCM',
    status: 'info',
  },
  'NTM-MISSING-CREDENTIALS': {
    display: 'App not configured to receive push',
    status: 'alert',
  },
  'NTM-NO-SUBSCRIPTIONS': {
    display: 'Callee not subscribed',
    status: 'alert',
  },
  'EVM-RESOURCE-ALLOCATION_FAILURE': {
    display: 'Call Setup failed',
    status: 'alert',
  },
  'EVM-RESOURCE-ALLOCATED': {
    display: 'Call Setup completed',
    status: 'info',
  },
};

const convertDisplayName = data => (serviceNameMapping[data] !== undefined
  ? serviceNameMapping[data]
  : { display: data, status: 'unknown' });

const sortStringData = function sortStringData(data, sortvalue, sortreverse) {
  const sortBy = (field, reverse, primer) => {
    const key = primer
      ? x => primer(x[field])
      : x => x[field];

    const reverse1 = !reverse ? 1 : -1;

    return (a, b) => {
      const a1 = key(a);
      const b1 = key(b);
      return reverse1 * ((a1 > b1) - (b1 > a1));
    };
  };

  let sortorder = true;
  if (sortreverse !== undefined && !sortreverse) {
    sortorder = false;
  }

  if (data[0]) {
    return data.sort(sortBy(sortvalue, sortorder));
  }
  return data;
};

const processCallDetails = (data) => {
  // const callData = [];
  const callData = {};
  let callTuple = {};
  let milestoneTuple = {};

  Object.keys(data).forEach((idx) => {
    if (data[idx] !== undefined) {
      const traceId = data[idx].key;
      let callStatus = 'success';
      const details = data[idx].milestones.buckets;
      callTuple = { traceId, values: [] };
      let topSrcTN = '__missing__';
      let topDstTN = '__missing__';

      Object.keys(details).forEach((mst) => {
        if (details[mst] !== undefined) {
          const milestone = details[mst].key;
          const eventMap = convertDisplayName(milestone);
          const milestoneDisplay = eventMap.display;
          const milestoneStatus = eventMap.status;
          const timestamps = details[mst].timestamp.buckets;
          if (milestoneStatus === 'alert') callStatus = 'failure';

          Object.keys(timestamps).forEach((itm) => {
            if (timestamps[itm] !== undefined) {
              const timestamp = timestamps[itm].key;
              const srcTN = timestamps[itm].srcTN.buckets[0].key;
              if (srcTN !== '__missing__') topSrcTN = srcTN;
              const dstTN = timestamps[itm].srcTN.buckets[0].dstTN.buckets[0].key;
              if (dstTN !== '__missing__') topDstTN = dstTN;

              milestoneTuple = {
                milestone,
                milestoneDisplay,
                milestoneStatus,
                timestamp,
                srcTN,
                dstTN,
              };
              callTuple.srcTN = topSrcTN;
              callTuple.dstTN = topDstTN;
              callTuple.callStatus = callStatus;
              callTuple.values.push(milestoneTuple);
            }
          });
        }
      });

      callTuple.values = sortStringData(callTuple.values, 'timestamp', false);
      callData[traceId] = callTuple;
    }
  });
  return callData;
};

export default processCallDetails;
